import { defineMessages } from 'react-intl';

const translations = {
  properties: {
    position: {
      id: 'properties.position',
      defaultMessage: 'Position',
      description: 'title of the position property',
    },
    shipment: {
      id: 'properties.shipment',
      defaultMessage: 'Shipment',
      description: 'title of the shipment property',
    },
    shipAt: {
      id: 'properties.shipAt',
      defaultMessage: 'Ship at',
      description: 'title of the ship at property',
    },
    shippingAddress: {
      id: 'properties.shippingAddress',
      defaultMessage: 'Shipping address',
      description: 'title of the shipping address property',
    },
    shippingMethod: {
      id: 'properties.shippingMethod',
      defaultMessage: 'Shipping method',
      description: 'title of the shipping method property',
    },
  },
};

export default defineMessages(translations);
